export default __webpack_public_path__ + "static/media/locate.81236529.svg";